module.exports = __webpack_public_path__ + "img/avatar7.cc33b9ad.png";